(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  (() => {
    const itemSelector = '.product-grid__item[data-product-id]';
    const badgeSelector = '[data-nw-ranking-badge]';

    const getCollectionUrl = (pathSuffix = '') => {
      const collectionPath = window.location.pathname.replace(/\/$/, '');
      return new URL(`${collectionPath}${pathSuffix}`, window.location.origin);
    };

    const getRankingPage = async (page) => {
      const rankingsUrl = getCollectionUrl();
      rankingsUrl.searchParams.set('view', 'nw-rankings');
      rankingsUrl.searchParams.set('sort_by', 'best-selling');
      rankingsUrl.searchParams.set('page', String(page));
      const response = await fetch(rankingsUrl.toString());
      if (!response.ok) {
        throw new Error('Unable to load view rankings');
      }
      const data = await response.json();
      if (!data || !Array.isArray(data.products)) {
        throw new Error('Invalid collection rankings');
      }
      const expectedHandle = document.querySelector('results-list')?.dataset.nwCollectionHandle || '';
      if (data.collectionHandle !== expectedHandle || data.sortBy !== 'best-selling') {
        throw new Error('Collection rankings were not sorted by best-selling');
      }
      return data;
    };

    const getRankings = async () => {
      const resultsList = document.querySelector('results-list');
      const emptyRankings = {
        bestSellerIds: new Set(),
        mostPopularIds: new Set(),
        labels: {
          bestSeller: resultsList?.dataset.nwBestSellerLabel || '',
          mostPopular: resultsList?.dataset.nwMostPopularLabel || '',
        },
      };
      let firstPage;

      try {
        firstPage = await getRankingPage(1);
      } catch {
        return emptyRankings;
      }

      const bestSellerIds = new Set(
        firstPage.products
          .filter((product) => product && product.id)
          .slice(0, 3)
          .map((product) => String(product.id))
      );
      const parsedTotalPages = Number(firstPage.totalPages);
      const totalPages = Number.isFinite(parsedTotalPages)
        ? Math.max(1, Math.trunc(parsedTotalPages))
        : 1;
      const pages = [firstPage];

      try {
        for (let page = 2; page <= totalPages; page += 1) {
          pages.push(await getRankingPage(page));
        }
      } catch {
        return {
          ...emptyRankings,
          bestSellerIds,
        };
      }

      const products = pages.flatMap((page) => page.products);
      const mostPopularIds = new Set(
        products
          .map((product, index) => ({
            id: String(product.id),
            index,
            viewCount: Number(product.viewCount),
            hasViewCount: product.hasViewCount === true,
          }))
          .filter((product) => product.hasViewCount && Number.isFinite(product.viewCount))
          .sort((a, b) => b.viewCount - a.viewCount || a.index - b.index)
          .slice(0, 3)
          .map((product) => product.id)
      );

      return {
        ...emptyRankings,
        bestSellerIds,
        mostPopularIds,
      };
    };

    const removeBadge = (item) => {
      item.querySelector(badgeSelector)?.remove();
    };

    const decorateCards = (rankings) => {
      const bestSellerLabel = String(rankings.labels.bestSeller || '');
      const mostPopularLabel = String(rankings.labels.mostPopular || '');

      document.querySelectorAll(itemSelector).forEach((item) => {
        const productId = String(item.dataset.productId || '');
        const label = rankings.bestSellerIds.has(productId)
          ? bestSellerLabel
          : rankings.mostPopularIds.has(productId)
            ? mostPopularLabel
            : '';
        const gallery = item.querySelector('.card-gallery');
        const existingBadge = item.querySelector(badgeSelector);

        if (!label || !gallery) {
          existingBadge?.remove();
          return;
        }

        const badge = existingBadge || document.createElement('span');
        badge.className = 'nw-sale-badge';
        badge.setAttribute('data-nw-ranking-badge', '');
        badge.textContent = label;

        if (badge.parentElement !== gallery) {
          gallery.append(badge);
        }
      });
    };

    const initialize = async () => {
      const rankings = await getRankings();

      let animationFrame;
      const scheduleDecoration = () => {
        if (animationFrame) {
          return;
        }

        animationFrame = window.requestAnimationFrame(() => {
          animationFrame = undefined;
          decorateCards(rankings);
        });
      };
      const observer = new MutationObserver(scheduleDecoration);

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-product-id'],
      });

      decorateCards(rankings);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-reviews-verified"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function setJudgeMeSearchValue(input, value) {
      var descriptor = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');

      if (descriptor && descriptor.set) {
        descriptor.set.call(input, value);
      } else {
        input.value = value;
      }

      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function initJudgeMeEnhancements(root) {
      root.querySelectorAll('[data-nw-judgeme-live-widget]').forEach(function(widget) {
        if (widget.dataset.nwJudgeMeReady === 'true') return;

        var mount = widget.querySelector('.jdgm-all-reviews-widget-v2025, .jdgm-all-reviews-widget, .jdgm-widget');
        var filterBar = widget.querySelector('[data-nw-judgeme-category-filters]');
        var buttons = filterBar ? Array.prototype.slice.call(filterBar.querySelectorAll('[data-nw-judgeme-filter]')) : [];
        var prepareTimer;

        if (!mount) return;

        function updateActiveFilter(value) {
          var normalizedValue = String(value || '').trim().toLowerCase();
          var hasMatch = false;

          buttons.forEach(function(button) {
            var term = String(button.getAttribute('data-search-term') || '').trim().toLowerCase();
            var isActive = term === normalizedValue;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-pressed', String(isActive));
            if (isActive) hasMatch = true;
          });

          if (!hasMatch) {
            buttons.forEach(function(button) {
              button.classList.remove('is-active');
              button.setAttribute('aria-pressed', 'false');
            });
          }
        }

        function applyFilter(term, attempts, scrollPosition) {
          var currentMount = widget.querySelector('.jdgm-all-reviews-widget-v2025, .jdgm-all-reviews-widget, .jdgm-widget');
          if (!currentMount) return;
          var input = currentMount.querySelector('.jm-search-bar__input');
          var toggle = currentMount.querySelector('.jm-search-filter__toggle');

          scrollPosition = scrollPosition || { left: window.scrollX, top: window.scrollY };

          function restoreScrollPosition() {
            window.scrollTo(scrollPosition.left, scrollPosition.top);
          }

          if (!input && toggle && !toggle.classList.contains('jm-search-filter__toggle--active')) {
            toggle.click();
            window.requestAnimationFrame(restoreScrollPosition);
          }

          input = currentMount.querySelector('.jm-search-bar__input');
          if (!input && attempts < 12) {
            window.setTimeout(function() {
              applyFilter(term, attempts + 1, scrollPosition);
            }, 100);
            return;
          }

          if (!input) return;
          setJudgeMeSearchValue(input, term);
          input.dispatchEvent(new KeyboardEvent('keydown', {
            key: 'Enter',
            code: 'Enter',
            bubbles: true
          }));
          input.blur();
          window.requestAnimationFrame(restoreScrollPosition);
          updateActiveFilter(term);
        }

        function prepareWidget() {
          var currentMount = widget.querySelector('.jdgm-all-reviews-widget-v2025, .jdgm-all-reviews-widget, .jdgm-widget');
          if (!currentMount) return;

          // Disconnect observer to avoid infinite loops during DOM updates
          if (widget.nwJudgeMeObserver) {
            widget.nwJudgeMeObserver.disconnect();
          }

          // Safely remove temp hiding styles for legacy widgets if needed
          var tempStyle = widget.querySelector('.jdgm-temp-hiding-style');
          if (tempStyle) {
            tempStyle.remove();
          }

          var reviewWidget = currentMount.querySelector('.jm-review-widget');
          var reviewBody = currentMount.querySelector('.jm-review-widget__body');
          var searchInput = currentMount.querySelector('.jm-search-bar__input');

          if (filterBar && reviewWidget && reviewBody) {
            var reviewBodyParent = reviewBody.parentNode;
            var activeJudgeMeTab = currentMount.querySelector('.jdgm-tab--active');
            var storeReviewsActive = activeJudgeMeTab && /store reviews/i.test(activeJudgeMeTab.textContent || '');

            if (reviewBodyParent && (filterBar.parentNode !== reviewBodyParent || filterBar.nextElementSibling !== reviewBody)) {
              reviewBodyParent.insertBefore(filterBar, reviewBody);
            }
            filterBar.hidden = Boolean(storeReviewsActive);
          }

          currentMount.querySelectorAll('.jdgm-tab').forEach(function(tab) {
            if (tab.dataset.nwJudgeMeTabReady === 'true') return;
            tab.dataset.nwJudgeMeTabReady = 'true';
            tab.addEventListener('click', function() {
              window.setTimeout(prepareWidget, 0);
              window.setTimeout(prepareWidget, 120);
            });
          });

          searchInput = currentMount.querySelector('.jm-search-bar__input');
          if (searchInput && searchInput.dataset.nwJudgeMeReady !== 'true') {
            searchInput.dataset.nwJudgeMeReady = 'true';
            searchInput.addEventListener('input', function() {
              updateActiveFilter(searchInput.value);
            });
          }

          // Move and format verified purchase badges below review content
          var reviewItems = currentMount.querySelectorAll('.jm-review-item');
          console.log('[NW Debug] Found jm-review-items:', reviewItems.length);
          reviewItems.forEach(function(item) {
            var badge = item.querySelector('.jm-verified-buyer-badge');
            var content = item.querySelector('.jm-review-content');
            if (badge && content) {
              var textEl = badge.querySelector('.jm-verified-buyer-badge__text');
              if (textEl && !textEl.textContent.includes('✓')) {
                textEl.textContent = '✓ Verified Purchase';
              }
              if (content.nextElementSibling !== badge) {
                content.parentNode.insertBefore(badge, content.nextElementSibling);
              }
            }
          });

          // Reconnect observer to monitor subsequent updates on the parent widget wrapper
          if (widget.nwJudgeMeObserver) {
            widget.nwJudgeMeObserver.observe(widget, { childList: true, subtree: true });
          }
        }

        buttons.forEach(function(button) {
          button.addEventListener('click', function() {
            applyFilter(button.getAttribute('data-search-term') || '', 0);
          });
        });

        widget.dataset.nwJudgeMeReady = 'true';
        prepareWidget();

        widget.nwJudgeMeObserver = new MutationObserver(function() {
          window.clearTimeout(prepareTimer);
          prepareTimer = window.setTimeout(prepareWidget, 40);
        });
        widget.nwJudgeMeObserver.observe(widget, { childList: true, subtree: true });
      });
    }

    function initVideoModal(root) {
      var modal = document.querySelector('[data-nw-review-video-modal]');
      var player = modal ? modal.querySelector('[data-nw-review-video-player]') : null;
      var label = modal ? modal.querySelector('[data-nw-review-video-label]') : null;
      var closeButtons = modal ? modal.querySelectorAll('[data-nw-review-video-close]') : [];
      if (!modal || !player) return;

      function stopVideo() {
        player.pause();
        player.removeAttribute('src');
        player.load();
      }

      function closeModal() {
        stopVideo();
        modal.hidden = true;
        document.body.style.overflow = '';
      }

      root.querySelectorAll('.ec-video-tile').forEach(function(tile) {
        if (tile.dataset.nwVideoReady === 'true') return;
        tile.dataset.nwVideoReady = 'true';
        tile.addEventListener('click', function() {
          var src = tile.getAttribute('data-video-src');
          if (!src) return;
          player.src = src;
          if (label) label.textContent = tile.getAttribute('data-video-label') || '';
          modal.hidden = false;
          document.body.style.overflow = 'hidden';
          player.play().catch(function() {});
          var close = modal.querySelector('.nw-video-modal__close');
          if (close) close.focus();
        });
      });

      closeButtons.forEach(function(close) {
        if (close.dataset.nwVideoCloseReady === 'true') return;
        close.dataset.nwVideoCloseReady = 'true';
        close.addEventListener('click', closeModal);
      });

      if (modal.dataset.nwVideoModalReady !== 'true') {
        modal.dataset.nwVideoModalReady = 'true';
        document.addEventListener('keydown', function(event) {
          if (event.key === 'Escape' && !modal.hidden) closeModal();
        });
      }
    }

    function initReviewAnimations() {
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var groups = [
        { selector: '.quote-strip__left', type: 'slide-left' },
        { selector: '.quote-strip__proof li', type: 'slide-right', step: 70, max: 280 },
        { selector: '.ec-video-strip__head', type: 'lift' },
        { selector: '.ec-video-tile', type: 'lift', step: 65, max: 260 },
        { selector: '.featured-review__media', type: 'slide-left' },
        { selector: '.featured-review__content', type: 'slide-right', delay: 110 },
        { selector: '.nw-judgeme-section > .eyebrow, .nw-judgeme-section > .section-display-heading', type: 'lift', step: 80, max: 260 },
        { selector: '.origin-story__content > *', type: 'slide-left', step: 80, max: 320 },
        { selector: '.featured-products-section .fp-section-head', type: 'lift' },
        { selector: '.fp-card', type: 'lift', step: 55, max: 300 },
        { selector: '.stories-head', type: 'slide-left' },
        { selector: '.pain-point-card', type: 'lift', step: 70, max: 280 },
        { selector: '.stories-close', type: 'lift', delay: 140 },
        { selector: '.why-buy-left > *', type: 'slide-left', step: 75, max: 300 },
        { selector: '.why-buy-card', type: 'slide-right', delay: 120 },
        { selector: '.comparison-section .eyebrow, .comparison-section .reviews-title, .comparison-table-wrap, .comparison-note', type: 'lift', step: 80, max: 300 },
        { selector: '.guarantees-intro, .guarantee-block', type: 'lift', step: 90, max: 260 },
        { selector: '.final-cta__inner > *', type: 'lift', step: 80, max: 260 }
      ];

      var revealItems = [];

      groups.forEach(function(group) {
        document.querySelectorAll(group.selector).forEach(function(element, index) {
          if (element.dataset.reveal) return;
          var delay = group.delay || Math.min(index * (group.step || 60), group.max || 240);
          element.dataset.reveal = group.type || 'lift';
          element.style.setProperty('--reveal-delay', delay + 'ms');
          revealItems.push(element);
        });
      });

      if (!revealItems.length) return;

      if (reduceMotion || !('IntersectionObserver' in window)) {
        revealItems.forEach(function(item) {
          item.classList.add('is-revealed');
        });
        return;
      }

      document.body.classList.add('reveal-ready');

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -12% 0px' });

      revealItems.forEach(function(item) {
        observer.observe(item);
      });
    }

    function init(root) {
      initJudgeMeEnhancements(root || document);
      initVideoModal(root || document);
      initReviewAnimations();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function(event) {
      init(event.target || document);
    });

    document.addEventListener('shopify:section:unload', function(event) {
      event.target.querySelectorAll('[data-nw-judgeme-live-widget]').forEach(function(widget) {
        if (widget.nwJudgeMeObserver) widget.nwJudgeMeObserver.disconnect();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["redlight-hot-room"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('[data-nw-redlight-scroll]');
    if (!trigger) return;

    var target = document.querySelector('[data-nw-addons], .nw-pdp-addons');
    if (!target) return;

    event.preventDefault();

    var nav = document.querySelector('[data-nw-nav]');
    var offset = nav ? nav.getBoundingClientRect().height : 0;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset - 18;

    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });

    target.classList.add('nw-redlight-hot-room__addon-focus');
    window.setTimeout(function() {
      target.classList.remove('nw-redlight-hot-room__addon-focus');
    }, 1800);

    var options = Array.prototype.slice.call(target.querySelectorAll('[data-nw-addon-option], button, a'));
    var redlightOption = options.find(function(option) {
      var text = [
        option.getAttribute('data-addon-title'),
        option.getAttribute('aria-label'),
        option.textContent
      ].join(' ').toLowerCase();

      return text.indexOf('red') !== -1 || text.indexOf('infrared') !== -1 || text.indexOf('sauna elite') !== -1;
    });

    if (redlightOption && typeof redlightOption.focus === 'function') {
      window.setTimeout(function() {
        redlightOption.focus({ preventScroll: true });
      }, 520);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
